import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';
import Buffering from '../components/Buffering';

import ListCodeLists from '../components/ListCodeLists';
import SelectSerialization from '../components/SelectSerialization';
import ImportCodeListMapping from '../components/ImportCodeListMapping';

import dsd from "../classes/clsDSD";
import {getQueryStringParams} from '../utils/utils';

import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';


class CodeLists extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            MyFilters:{
                scope:'my',
                status: ''
            },
            PublishedFilters:{
                scope:'published'
            },
            countMy:null,
            countPublished:null,
            toggle: 0,
            idImportSerialization: null,
            importData: '',
            importMapping: null,
            importError: null,
            importSubmitting: false,
        };

        this.dsd = new dsd(this);

        this.handleButton = this.handleButton.bind(this);
        this.handleImport = this.handleImport.bind(this);
        this.setFilters = this.setFilters.bind(this);
        this.loadedMy = this.loadedMy.bind(this);
        this.loadedPublished = this.loadedPublished.bind(this);
        this.handleChange = this.handleChange.bind(this);

        this.handleMyFilters = this.handleFilters.bind(this,'MyFilters');
        this.handlePublishedFilters = this.handleFilters.bind(this,'PublishedFilters');
    }

    componentDidMount(){
        this.setup();
    }

    componentDidUpdate(prevProps){
        if (prevProps != this.props){
            this.setup();
        }
    }

    setup(){
        this.setLayoutContent();
        this.setState({ countMy:null, countPublished:null, isLoaded: true, idImportSerialization: null, importData: '', importMapping: null, importError: null, importSubmitting: false });
    }

    handleChange(event) {
        const name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({ [name]: value });
    }

    handleImport(event) {
        event.preventDefault();

        const m = this.state.importMapping || {};
        const mapping = {
            List: {
                startAt:     m.listRoot        || '',
                name:        m.listName        || '',
                description: m.listDescription || '',
                namespace:   m.listNamespace   || '',
                prefix:      m.listPrefix      || '',
            },
            Items: {
                startAt:    m.itemsRoot        || '',
                code:       m.itemsCode        || '',
                label:      m.itemsLabel       || '',
                definition: m.itemsDefinition  || '',
                usageNotes: m.itemsUsageNotes  || '',
                Parents: {
                    startAt: m.itemsParentsRoot || '',
                    code:    m.itemsParentsCode || '',
                },
            },
        };

        let data;
        try {
            data = JSON.parse(this.state.importData);
        } catch (e) {
            this.setState({ importError: 'Data is not valid JSON', importSubmitting: false });
            return;
        }

        this.setState({ importError: null, importSubmitting: true });

        const headers = { headers: { 'Content-type': 'application/json' } };
        const authHeader = this.dsd.authHeader();
        if (authHeader) { headers.headers.Authorization = authHeader.Authorization; }

        this.dsd.httpConfig.post('/codelists', { import: { data, mapping } }, headers)
            .then(response => {
                this.setState({ importSubmitting: false });
                this.props.navigation(`/codelist/${response.data._id}`);
            })
            .catch(e => {
                const msg = (e.response && e.response.data && e.response.data.message)
                    || e.message || 'Import failed';
                this.setState({ importError: msg, importSubmitting: false });
            });
    }

    handleButton(event) {
        switch (event.target.name){
            case 'btnAdd':
                this.props.navigation(`/codelist?mode=new`);
                break;
            default:
                break;
        };
        event.preventDefault();
    };

    handleFilters(StateVarName, event) {

        if (this.idFilterTimeout) {
            clearTimeout(this.idFilterTimeout);
        }

        let Filters = {};
        if (this.state[StateVarName]){
            Filters = this.state[StateVarName];
        }

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        Filters[FormFieldName] = FormFieldValue;

        switch (FormFieldName){
            case 'search':
                this.idFilterTimeout = setTimeout(this.setFilters, 500, StateVarName, Filters);
                return;
        }

        this.setFilters(StateVarName, Filters);
    };

    setFilters(StateVarName, Filters){
        var obj  = {}
        obj[StateVarName] = Filters
        if (StateVarName === 'MyFilters') obj.countMy = null;
        if (StateVarName === 'PublishedFilters') obj.countPublished = null;
        this.setState(obj);
        this.setState({"toggle":!this.state.toggle});
    };

    about(){

        if (this.dsd.model){
            return(
                <div>
                    <div>
                        {this.dsd.model.codelist && this.dsd.model.codelist.about &&
                            <PD.MdPresent>
                                {this.dsd.model.codelist.about}
                            </PD.MdPresent>
                        }
                    </div>
                </div>
            )
        }

        return <div/>
    }

    setLayoutContent(){

        if (this.context.hasLayout){
            let Content = {Index:{}};
            this.context.Layout.setLayoutContent(Content)
            localStorage.setItem("dsdContent",JSON.stringify(Content));
        }
    }

    loadedMy(count){
        this.setState({ countMy: count || 0 });
    }

    loadedPublished(count){
        this.setState({ countPublished: count || 0 });
    }

    render() {

        if (!this.dsd || !this.dsd.config || !this.dsd.model || !this.state.isLoaded) {
            return <div><Buffering/></div>
        }

        return (
            <div>
                <PD.Heading>Code Lists</PD.Heading>

                <PD.Tabs>

                    <div label="About">
                        {this.about()}
                    </div>

                    {this.dsd.loggedon &&
                        <div label={<span>My Code Lists({this.state.countMy === null ? <Buffering/> : this.state.countMy})</span>} data-forcerender="true">
                            <div style={{display:"flex"}}>
                                <PD.Button value='add a new Code List' name='btnAdd' onClick={this.handleButton}/>
                                <fieldset style={{display:"flex"}}>
                                    <legend>filters</legend>

                                    <PD.Radio label='Scope' name='scope' onChange={this.handleMyFilters} value={this.state.MyFilters.scope}>
                                        <label>my</label>
                                        <label>my deprecated</label>
                                    </PD.Radio>

                                    <PD.Select label='Status' name='status'
                                        onChange={this.handleMyFilters}
                                        value={this.state.MyFilters.status}
                                    >
                                        {
                                            this.dsd.config.ComponentStatuses.map(
                                                (status, posStatus) =>
                                                {
                                                    switch (status){
                                                        case 'deprecated':
                                                            return null;
                                                        default:
                                                            return(
                                                                <option key={posStatus} value={status}>{status}</option>
                                                            )
                                                    }
                                                }
                                            )
                                        }
                                    </PD.Select>

                                    <PD.Input label="Search" width="15" name="search" value={this.state.MyFilters.search} onChange={this.handleMyFilters}/>

                                </fieldset>
                            </div>

                            <ListCodeLists filters={this.state.MyFilters} columns={{status:true}} toggle={this.state.toggle} onLoad={this.loadedMy}/>

                        </div>
                    }


                    <div label={<span>Published Code Lists({this.state.countPublished === null ? <Buffering/> : this.state.countPublished})</span>} data-forcerender="true">
                        <div style={{display:"flex"}}>
                            <fieldset style={{display:"flex"}}>
                                <legend>filters</legend>
                                <PD.Input label="Search" width="15" name="search" value={this.state.PublishedFilters.search} onChange={this.handlePublishedFilters}/>
                            </fieldset>
                        </div>

                        <ListCodeLists filters={this.state.PublishedFilters} columns={{owner:true}} toggle={this.state.toggle} onLoad={this.loadedPublished}/>

                    </div>

                    {this.dsd.loggedon &&
                        <div label='Import'>
                            <SelectSerialization
                                name="idImportSerialization"
                                label="Serialization"
                                selectDataSpec={true}
                                value={this.state.idImportSerialization}
                                onChange={this.handleChange}
                            />
                            {this.state.idImportSerialization &&
                                <ImportCodeListMapping
                                    idSerialization={this.state.idImportSerialization}
                                    onChange={(mapping) => this.setState({ importMapping: mapping })}
                                />
                            }
                            {(() => {
                                const m = this.state.importMapping || {};
                                const canImport = this.state.idImportSerialization
                                    && this.state.importData
                                    && m.itemsCode;
                                return canImport ? (
                                    <div style={{ marginTop: 12 }}>
                                        <button
                                            onClick={this.handleImport}
                                            disabled={this.state.importSubmitting}
                                            style={{ backgroundColor: 'green', color: 'white', padding: '6px 18px', border: 'none', borderRadius: 4, cursor: 'pointer', fontWeight: 'bold' }}
                                        >
                                            {this.state.importSubmitting ? 'Importing…' : 'Import'}
                                        </button>
                                    </div>
                                ) : null;
                            })()}
                            {this.state.importError &&
                                <PD.ErrorBox>{this.state.importError}</PD.ErrorBox>
                            }
                            <div style={{ marginTop: 12 }}>
                                <label style={{fontWeight:'bold'}}>Data</label>
                                <div>
                                    <textarea
                                        name="importData"
                                        value={this.state.importData}
                                        onChange={this.handleChange}
                                        rows={15}
                                        style={{width:'100%', fontFamily:'monospace', boxSizing:'border-box'}}
                                    />
                                </div>
                            </div>
                        </div>
                    }

                </PD.Tabs>
            </div>
        )
    };
};

export default function CodeLists_wrapper(props) {
    const navigation = useNavigate();
    const location = useLocation();
    return <CodeLists {...props} navigation={navigation} location={location} />;
}
